import { Dayjs } from "dayjs";

export interface IError {
    description: string;
}


export interface BoothClientModel {
    boothId: string;
    name: string;
}

export interface ReportType {
    Name: string;
    Endpoint: string;
}

export interface FilterModel {
    from: Dayjs;
    to: Dayjs;
    boothIds: string[];
    vrmvin: string;
    reportType: ReportType;
}

export enum ReportLoadingType {
    Loading,
    Error,
    Noreports,
    Loaded,

    SelectClient, // billing

    SelectSalesman, // commission
}


export function GetReportTypes(): Array<ReportType> {
    return ReportTypes;
}

const ReportTypes: Array<ReportType> = [
    { Name: "Combined", Endpoint: "CombinedReport" },
    { Name: "Desktop ICC", Endpoint: "DesktopReport" },
    { Name: "Mobile ICC", Endpoint: "MobileReport" },
    { Name: "Summary", Endpoint: "SummaryReport" },
    { Name: "Multi-images", Endpoint: "MultiImagesReport" },
]